export default __webpack_public_path__ + "static/media/logobridge2.fa654b54.png";